<template>
  <div class="BaseArticlePage">
    <BaseCommonPage>
      <div class="fun_container area_funcontents">
       
        <img
          :src="app_root + '/assets/designpaper_lp/images/top.jpg'"
          class="img-responsive center-block"
        />

        <div class="container-fluid">
          <div class="container">
            <div class="row">
              <div class="col-md-12 col-sm-12">

                <p
                  class="indent_caption"
                  style="
                    font-weight: bold; 
                    text-align: center; 
                    text-decoration: underline;"
                >
                  まずは無料アプリをインストール
                </p>

                <!-- アプリインストール -->
                <div class="flex">
                  <figure class="image">
                    <img :src="app_root + '/assets/common/img/creativeprint_icon.png'"
                      class="install_img icon_img"
                    />
                  </figure>
                  <div class="right">
                    <p class="icon_title">Epson Creative Print</p>
                    <p class="text">
                      <AppCompatiblePrinters appName="creative" />
                    </p>
                  </div>
                </div>

                <div class="app_badge">
                  <a
                    v-on:click="trackGa4AppDownloadEvent()"
                    href="https://geo.itunes.apple.com/us/app/epson-creative-print/id685791389?pt=280580&ct=gallery_lp_insta202403&mt=8"
                    target="itunes_store"
                    >
                    <img :src="app_root + '/assets/common/img/button/Download_on_the_App_Store_Badge_US-UK_135x40.svg'"
                      class="app_store"
                    />
                  </a>
                  <a
                    v-on:click="trackGa4AppDownloadEvent()"
                    href="https://play.google.com/store/apps/details?id=com.epson.mobilephone.creative&utm_source=gallery_lp&utm_campaign=insta_dp_202403"
                    target="itunes_store"
                    >
                    <img :src="app_root + '/assets/common/img/button/google-play-badge.png'"
                      class="google_play"
                    />
                  </a>

                </div>
                <!-- アプリインストールここまで -->

                <h3 class="thema_func">
                  Epson Creative Print でデザインペーパーを印刷しよう!
                </h3>

                <p>
                  おうちのエプソンプリンターから、300種類以上のデザインペーパーを使いたい分だけ印刷できます。
                  <br>多彩なデザインの中からお気に入りを見つけて、ラッピングやハンドメイド素材として活用してみてくださいね！
                </p>

                
                <h3 class="thema_func top_margin">
                  デザインペーパー 活用例と春の人気柄をご紹介
                </h3>

                <img
                  :src="app_root + '/assets/designpaper_lp/images/idea.jpg'"
                  class="img-responsive center-block"
                />

                <p class="introduction_h indent_caption">
                  春の人気柄はやっぱり桜やミモザ。
                  <br>
                  定番のハート柄やスイーツ柄もラッピングやハンドメイド作品に使いやすくておすすめです。
                </p>

                <!-- デザインペーパーサムネイル -->
                <div class="row preview top_margin">

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/41-61.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/59-35.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/31-63.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/60-07.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/31-66.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/59-23.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/31-61.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/60-15.png'"
                      class="thumnail-image"
                    />
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                    <img 
                      :src="app_root + '/assets/common/img/fun/designpaper/thumnails/41-72.png'"
                      class="thumnail-image"
                    />
                  </div>

                </div>
                <!-- デザインペーパーサムネイル ここまで-->

                <h3 class="thema_func top_margin">アプリの使い方は簡単！</h3>
                <p class="introduction_h indent_caption">
                  アプリを開くと「デザインペーパー」アイコンがあります。アイコンをタップするとデザインペーパー一覧が出てくるので、好きな柄を選んで印刷するだけ！
                </p>

                <img
                  :src="app_root + '/assets/designpaper_lp/images/app_howto.jpg'"
                  class="img-responsive center-block"
                />

                <h3 class="thema_func top_margin">
                  アプリを使っておうちでデザインペーパーを印刷しよう！
                </h3>

                 <!-- アプリインストール -->
                 <div class="flex">
                  <figure class="image">
                    <img :src="app_root + '/assets/common/img/creativeprint_icon.png'"
                      class="install_img icon_img"
                    />
                  </figure>
                  <div class="right">
                    <p class="icon_title">Epson Creative Print</p>
                    <p class="text">
                      <AppCompatiblePrinters appName="creative" />
                    </p>
                  </div>
                </div>

                <div class="app_badge">
                  <a
                    v-on:click="trackGa4AppDownloadEvent()"
                    href="https://geo.itunes.apple.com/us/app/epson-creative-print/id685791389?pt=280580&ct=gallery_lp_insta202403&mt=8"
                    target="itunes_store"
                    >
                    <img :src="app_root + '/assets/common/img/button/Download_on_the_App_Store_Badge_US-UK_135x40.svg'"
                      class="app_store"
                    />
                  </a>
                  <a
                    v-on:click="trackGa4AppDownloadEvent()"
                    href="https://play.google.com/store/apps/details?id=com.epson.mobilephone.creative&utm_source=gallery_lp&utm_campaign=insta_dp_202403"
                    target="itunes_store"
                    >
                    <img :src="app_root + '/assets/common/img/button/google-play-badge.png'"
                      class="google_play"
                    />
                  </a>

                </div>
                <!-- アプリインストールここまで -->

              </div>
              <!-- End col-md-12 col-sm-12 -->
            </div>
              <!-- End row -->

          </div>
          <!-- End container -->
        </div>
        <!-- End container-fluid -->
      </div>
    </BaseCommonPage>
  </div>
  <!-- End BaseArticlePage -->
</template>

<script>
import BaseCommonPage from "./BaseCommonPage";
import AppCompatiblePrinters from "../components/AppCompatiblePrinters";
// import LabelFunMessage from "../components/LabelFunMessage";

export default {
  name: "DesignPaperLandingPage",
  components: {
    BaseCommonPage,
    AppCompatiblePrinters,
    //LabelFunMessage,
  },
  computed: {
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
    };
  },
  methods: {
    trackGa4AppDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Creative Print",
        "location_id": "article",
        "article_no": "designpaper_lp",
        "site_id": "gallery"
      })
    }
  },
  metaInfo() {
    return {
      title: "Epson Creative Print でデザインペーパーを印刷しよう!",
      meta: [
        {
          name: "description",
          content: "Epson Creative Print でデザインペーパーを印刷しよう!",
        },
      ],
    };
  },
};
</script>

<style scoped>
.thema_func {
  line-height: 1.2;
}
.top_margin {
  margin-top: 35px;
}

.flex {
  display: flex; /*横並び*/
}
.flex .image {
  max-width: 100px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
}
.flex .right {
  margin: 0 0 0 20px;
  padding: 0;
}

.flex .icon_title {
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0 5px 0;
  padding: 0;
  text-align: center;
}

.flex .text {
  font-size: 12px;
  padding: 0;
}
.app_badge {
  margin: 0px 0px 30px 0px;
}

/* スマホサイズのみの指定 */
@media screen and (max-width: 480px) {
  .thema_func {
    font-size: 20px;
    font-weight: bold;
  }
  
  .flex .image {
  max-width: 65px;
}
  .flex .right {
  margin: 0 0 0 10px;
  padding: 0;
}
  .flex .icon_title {
    font-size: 16px;
  }
  .icon_img {
    max-width: 100%;
    height: auto;
  }

}

</style>
